import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { GlassHouse5By7ShelfTalkerContentViewModel } from './glass-house-5-by-7-shelf-talker-content-view-model';
import { ShelfTalkerCardContentComponent } from '../../shared/shelf-talker-card-content.component';

@Component({
  selector: 'app-glass-house-5-by-7-shelf-talker-content',
  templateUrl: './glass-house-5-by-7-shelf-talker-content.component.html',
  styleUrls: ['./glass-house-5-by-7-shelf-talker-content.component.scss'],
  providers: [GlassHouse5By7ShelfTalkerContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GlassHouse5By7ShelfTalkerContentComponent extends ShelfTalkerCardContentComponent {
  constructor(
    public viewModel: GlassHouse5By7ShelfTalkerContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
